import { create } from 'zustand';

export type DailySessionTimeLimitSteps = 'prologue' | 'time-selection' | 'acknowledgement' | 'mfa';

interface DailySessionTimeLimitRequestDialogState {
    isOpen: boolean;
    step: DailySessionTimeLimitSteps;
    // Whole hours per day (0 disables).
    hoursPerDay: number;
    actions: {
        open: () => void;
        close: () => void;
        setHoursPerDay: (hours: number) => void;
        setStep: (step: DailySessionTimeLimitSteps) => void;
        reset: () => void;
    };
}

const initialState: Omit<DailySessionTimeLimitRequestDialogState, 'actions'> = {
    isOpen: false,
    step: 'prologue',
    hoursPerDay: 0,
};

export const useDailySessionTimeLimitRequestDialogStore = create<DailySessionTimeLimitRequestDialogState>()((set) => ({
    ...initialState,
    actions: {
        open: () => set({ ...initialState, isOpen: true }),
        close: () => set({ isOpen: false }),
        setHoursPerDay: (hours) => set({ hoursPerDay: hours }),
        setStep: (step) => set({ step }),
        reset: () => set(initialState),
    },
}));
